import { PropsWithChildren } from "react";

export default function ButtonWithNotifications({ notifications, icon, onClick }: PropsWithChildren<{ notifications: number; onClick: () => any; icon: JSX.Element }>) {
  return <button onClick={onClick} className="flex relative">
    {icon}
    {notifications > 0 && <div className="absolute top-[-7px] right-[-7px] bg-red-600 w-[1.2rem] h-[1.2rem] flex items-center justify-center rounded-full">
      <span className="text-white text-xs">{notifications > 10 ? '9+' : notifications}</span>
    </div>}
  </button>
}

